import { SyncJobType } from "../enums/sync-job-type";
import { SyncJobStatus } from "../enums/sync-job-status";

export interface IAccountingSyncJob {
  id: string;
  type: SyncJobType;
  status: SyncJobStatus;
  totalItems: number;
  createdAt: Date;
  updatedAt: Date;
}
